<template>
  <div class="login">
    <div class="container">
      <div class="left">
        <!-- <img src="https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1536658095028&di=9bf38bf5e91ad9e4296a9ad739ee941b&imgtype=jpg&src=http%3A%2F%2Fimg4.imgtn.bdimg.com%2Fit%2Fu%3D2236400314%2C266814909%26fm%3D214%26gp%3D0.jpg" alt=""> -->
      </div>
      <div class="right">
        <h2 class="title">V货帮物流管理平台</h2>
        <el-form label-position="top"
                 :model="loginForm"
                 status-icon
                 :rules="rules"
                 ref="loginForm"
                 label-width="100px"
                 class="demo-ruleForm">
          <el-form-item label="登录名"
                        prop="username">
            <el-input type="text"
                      v-model="loginForm.username"
                      auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="密码"
                        prop="pass">
            <el-input type="password"
                      v-model="loginForm.pass"
                      auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
            <el-checkbox label="记住密码"
                         v-model="checked"
                         name="type"></el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       @click="submitForm('loginForm')"
                       class="submitBtn">登录</el-button>
          </el-form-item>
        </el-form>
        <div class="copyright">
          Copyright &copy; 2015-2016 V货帮物流管理平台 V 3.0.1
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { login, menu } from 'apis/index'
// console.log(login)
export default {
  name: 'Login',
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var validateUsername = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else {
        callback()
      } callback(new Error('请输入密码'))
    }
    return {
      checked: true,
      loginForm: {
        username: '',
        pass: ''
      },
      rules: {
        username: [
          { validator: validateUsername, trigger: 'blur' }
        ],
        pass: [
          { validator: validatePass, trigger: 'blur' }
        ]

      }
    }
  },
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // alert('submit!')
          let loginUserName = this.loginForm.username
          let loginUserPassword = this.loginForm.pass
          if (this.checked) { // 记住密码
            this.setCookie(loginUserName, loginUserPassword, 7)
          } else { // 取消记住密码
            this.clearCookie()
          }

          login({ loginUserName, loginUserPassword }).then(res => {
            // 假设登陆成功
            if (res.data.code === 200) {
              // console.log(res)
              window.localStorage.setItem('token', 'islogin')
              window.localStorage.setItem('username', res.data.data)
              // localStorage.setItem('menulist', JSON.stringify(data.data))
              // let loginInfo = {
              //   'token': 'islogin',
              //   'username': res.data.desc
              // }
              // window.localStorage.setItem('loginInfo', loginInfo)
              this.getMenuData()
              this.$router.push('/')
            } else {
              // console.log(res)
              this.$message.error('登陆失败:' + res.data.desc)
            }
          })
        } else {
          // console.log('error submit!!')
          return false
        }
      })
    },
    setCookie (loginname, loginPassword, exdays) {
      var exdate = new Date() // 获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays) // 保存的天数
      // 字符串拼接cookie
      window.document.cookie = 'userName' + '=' + loginname + ';path=/;expires=' + exdate.toGMTString()
      window.document.cookie = 'userPwd' + '=' + loginPassword + ';path=/;expires=' + exdate.toGMTString()
    },
    // 读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; ') // 这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('=') // 再次切割
          // 判断查找相对应的值
          if (arr2[0] === 'userName') {
            this.loginForm.username = arr2[1] // 保存到保存数据的地方
          } else if (arr2[0] === 'userPwd') {
            this.loginForm.pass = arr2[1]
          }
        }
      }
    },
    // 清除cookie
    clearCookie: function () {
      this.setCookie('', '', -1) // 修改2值都为空，天数为负1天就好了
    },
    // 获取菜单
    getMenuData () {
      menu().then(res => {
        // console.log(res)
        if (res.data.code === 200) {
          localStorage.setItem('menulist', JSON.stringify(res.data.data))
        }
      })
    }
  },
  mounted () {
    this.getCookie()
  }
}
</script>
<style lang="stylus">
@import '~styles/mixins.styl'
.login
  position absolute
  left 0px
  right 0px
  top 0px
  bottom 0px
  background-image url('../assets/images/01/bg0001.png'), url('../assets/images/01/bg0002.png'), url('../assets/images/01/bg0003.png')
  background-repeat no-repeat, no-repeat, no-repeat
  background-position left 0px top 68px, right top, right 23px bottom 47px
  .container
    width 772px
    height 514px
    position absolute
    left 50%
    top 50%
    margin-left -360px
    margin-top -231px
    background url('../assets/images/01/Fill_1.png') no-repeat
    .left
      width 386px
      height 514px
      float left
      radius 10px
      overflow hidden
      img
        width 100%
        height 100%
    .right
      width 360px
      height 480px
      float left
      position relative
      .title
        font-size 18px
        text-align center
        margin 70px 0 40px 0
        color #212832
        font-weight 600
      .el-form-item
        padding-left 68px
        margin-bottom 15px
        .el-form-item__label
          line-height 20px
          font-size 12px
          color #858C96
        .el-input
          width 224px
          height 34px
        .el-input__inner
          height 34px
          line-height 34px
        .submitBtn
          width 224px
          height 34px
          margin-top 28px
          line-height 0
        .el-checkbox__label
          font-size 12px
          color #ADB4BE
        .el-form-item__content
          line-height 20px
          position relative
          font-size 12px
      .copyright
        size10()
        width 100%
        bottom 17px
        color #adb4be
        text-align center
        position absolute
        left 50%
        transform translate(-50%)
</style>
